import script from "./DocumentsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsPage.vue?vue&type=script&setup=true&lang=js"

import "./DocumentsPage.vue?vue&type=style&index=0&id=35cb09fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35cb09fd"]])

export default __exports__